import { render, staticRenderFns } from "./CartBox.vue?vue&type=template&id=a5d58e88&scoped=true"
import script from "./CartBox.vue?vue&type=script&lang=js"
export * from "./CartBox.vue?vue&type=script&lang=js"
import style0 from "./CartBox.vue?vue&type=style&index=0&id=a5d58e88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d58e88",
  null
  
)

export default component.exports